import type { ComponentProps, ReactNode } from 'react';

import { cn } from '../lib/cn';

export function Card({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'rounded-xl border bg-card text-card-foreground shadow-card',
        // Una tabla dentro de una tarjeta no lleva marco propio: sólo la línea que la separa.
        '[&_[data-slot=table]]:rounded-none [&_[data-slot=table]]:border-x-0 [&_[data-slot=table]]:border-b-0 [&_[data-slot=table]]:shadow-none',
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('flex flex-col gap-1.5 p-5 pb-3', className)} {...props} />;
}

/**
 * Título de tarjeta. Con `icon`, el ícono va en un cuadro teñido a la izquierda: da un ancla visual
 * a cada sección sin competir con el texto.
 */
export function CardTitle({
  className,
  icon,
  children,
  ...props
}: ComponentProps<'h3'> & { icon?: ReactNode }) {
  return (
    <h3
      className={cn(
        'text-base leading-tight font-semibold tracking-tight',
        icon ? 'flex items-center gap-2.5' : null,
        className,
      )}
      {...props}
    >
      {icon ? (
        <span
          aria-hidden
          className="flex size-7 shrink-0 items-center justify-center rounded-lg bg-accent text-highlight ring-1 ring-highlight/10 ring-inset [&_svg]:size-[0.95rem]"
        >
          {icon}
        </span>
      ) : null}
      {children}
    </h3>
  );
}

export function CardDescription({ className, ...props }: ComponentProps<'p'>) {
  return <p className={cn('text-sm text-muted-foreground', className)} {...props} />;
}

export function CardContent({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('p-5 pt-2', className)} {...props} />;
}

export function CardFooter({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('flex items-center gap-2 border-t p-4', className)} {...props} />;
}
